
import { Vue, Component } from 'vue-property-decorator';
import AdminCmsCredentialsTable from '@/ui/components/molecules/tables/AdminCmsCredentialsTable.vue';

@Component({
  name: 'AdminCmsCredentialsTab',
  components: { AdminCmsCredentialsTable },
})
export default class AdminCmsCredentialsTab extends Vue {}
